// extracted by mini-css-extract-plugin
module.exports = {"form":"ForgottenPassword_form__57sVN","infText":"ForgottenPassword_infText__ebWM2","error":"ForgottenPassword_error__F4QOC","success":"ForgottenPassword_success__DGtz1"};